import * as React from 'react';
import { Docs, Link } from 'docz';
import styled from 'react-emotion';
import get from 'lodash/get';
import { get as themeGet } from '@utils/theme';
const primaryColor = themeGet('colors.primary');
const Submenu = styled('div') `
  display: flex;
  flex-direction: column;
  margin: 5px 0 0;
  position: relative;
`;
const SmallLink = styled(Link) `
  position: relative;
  font-size: 15px;
  font-weight: 400;
  padding: 6px var(--sidebar-padding) 6px
    calc(var(--sidebar-padding) + ${p => (p.level + 1) * 10}px);
  text-decoration: none;
  opacity: 0.8;
  transition: opacity 0.2s;

  &:first-line {
    line-height: 22px;
  }

  &,
  &:hover,
  &:focus,
  &:visited,
  &.active {
    color: ${themeGet('colors.sidebarText')};
  }

  &.active {
    font-weight: 600;
    opacity: 1;
  }

  &:before {
    z-index: 1;
    position: absolute;
    display: block;
    content: '';
    top: 0;
    left: 0;
    width: 0;
    height: 30px;
    background: ${primaryColor};
    transition: width 0.2s;
  }

  &.active:before {
    width: 3px;
  }
`;
const isSmallLinkActive = (slug) => (m, location) => slug === location.hash.slice(1, Infinity);
const getHeadings = (route, docs) => {
    const doc = docs.find(doc => doc.route === route);
    const headings = get(doc, 'headings');
    return headings ? headings.filter(heading => heading.depth === 2) : [];
};
export const MenuHeadings = ({ route, onClick, level, }) => (React.createElement(Docs, null, ({ docs }) => {
    const headings = getHeadings(route, docs);
    return (headings.length > 0 && (React.createElement(Submenu, null, headings.map((heading) => (React.createElement(SmallLink, { key: heading.slug, onClick: onClick, to: { pathname: route, hash: heading.slug }, isActive: isSmallLinkActive(heading.slug), level: level }, heading.value))))));
}));
//# sourceMappingURL=data:application/json;base64,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